import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Layout } from 'antd';
import { Route, Routes } from 'react-router-dom';
import { Header } from 'common/components/Header';
import { ERoutes } from 'common/const/enums.const';
import { PrivateLayout } from 'common/components/PrivateLayout';
import { RootDispatch } from 'app/store';
import { LoginPage } from 'entities/Auth/components/LoginPage';
import { AuthPage } from 'entities/Auth/components/AuthPage';

type AllType = ReturnType<typeof mapDispatch>;

const AppComponent: React.FC<AllType> = ({ initAuthModel }) => {
  useEffect(() => {
    initAuthModel();
  }, []);

  return (
    <Layout>
      <Header />

      <Routes>
        <Route path={ERoutes.Login} element={<LoginPage />} />
        <Route path={ERoutes.Auth} element={<AuthPage />} />
        <Route path="*" element={<PrivateLayout />} />
      </Routes>
    </Layout>
  );
};

const mapDispatch = (dispatch: RootDispatch) => ({
  initAuthModel: dispatch.authModel.initAuthModel,
});

export const App = connect(null, mapDispatch)(AppComponent);
